// A session's path, as the sessions list and an issue's sessions show it: the screens it went
// through in order, and how many more there were.
import type { ReactNode } from 'react'
import { useI18n } from '../i18n'

/** Home → Cart → Checkout, and how many screens more. */
export function SessionPath({ screens, more }: { screens: string[]; more: number }) {
  const { t } = useI18n()
  // No screen: the console's empty dash, plain, as the other tables' cells.
  if (screens.length === 0) return '—'
  const parts: ReactNode[] = []
  screens.forEach((s, i) => {
    if (i > 0)
      parts.push(
        // biome-ignore lint/suspicious/noArrayIndexKey: a path's screens keep their order
        <span key={`a${i}`} className="faint" aria-hidden="true">
          →
        </span>,
      )
    // A line may break after an arrow, so a long path wraps in a cell that allows it.
    // biome-ignore lint/suspicious/noArrayIndexKey: a path's screens keep their order
    if (i > 0) parts.push(<wbr key={`w${i}`} />)
    // biome-ignore lint/suspicious/noArrayIndexKey: a path may visit a screen twice
    parts.push(<span key={`s${i}`}>{s}</span>)
  })
  return (
    <span translate="no">
      {parts}
      {more > 0 ? <span className="faint"> {t('sessions.path.more', { count: more })}</span> : null}
    </span>
  )
}
